import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";

import { PlusArchiveTitle } from "scmp-app/components/plus/archive/archive-title";
import { usePlusArticlePopup } from "scmp-app/components/plus/article-popup/hooks";
import { usePlusDetailedListingPopup } from "scmp-app/components/plus/detailed-listing-popup/hooks";
import type { openQuestionsSeriesPlusArchiveQuery$key } from "scmp-app/queries/__generated__/openQuestionsSeriesPlusArchiveQuery.graphql";

import { Container, ContentItemContainer, StyledContentItemPlusPrimary } from "./styles";

type Props = {
  className?: string;
  reference: openQuestionsSeriesPlusArchiveQuery$key;
};
export const PlusArchiveOpenQuestionsSeries: FunctionComponent<Props> = ({
  className,
  reference,
}) => {
  const content = useFragment(
    graphql`
      fragment openQuestionsSeriesPlusArchiveQuery on Query
      @argumentDefinitions(openQuestionsSeriesTypeUuid: { type: "String!" }) {
        plusArchiveOpenQuestionsSeries: contents(
          filter: { topicIds: [$openQuestionsSeriesTypeUuid] }
          first: 4
          orderBy: { field: PUBLISHED_DATE, direction: DESC }
        ) {
          edges {
            node {
              entityId
              ...plusPrimaryContentItemContent
              ...hooksPlusArticleLinkHandlerArticle
            }
          }
        }
      }
    `,
    reference,
  );

  const { handleOpen: handleOpenDetailedListingPopup } = usePlusDetailedListingPopup();
  const { handleOpen: handleOpenArticlePopup } = usePlusArticlePopup();

  return (
    <BaseLinkContextProvider
      customQueryParameters={{
        module: "open_questions_series",
      }}
    >
      <Container className={className}>
        <PlusArchiveTitle
          onClick={() =>
            handleOpenDetailedListingPopup({
              pgtype: "archive",
              type: "open-questions-series",
            })
          }
          title="Open Questions Series"
        />
        <ContentItemContainer>
          {content?.plusArchiveOpenQuestionsSeries.edges.map(edge => (
            <StyledContentItemPlusPrimary
              key={edge.node.entityId}
              onClick={() =>
                handleOpenArticlePopup(edge.node, {
                  pageType: "archive",
                  widgetName: "open_questions",
                })
              }
              reference={edge.node}
              withArticleType={false}
            />
          ))}
        </ContentItemContainer>
      </Container>
    </BaseLinkContextProvider>
  );
};

PlusArchiveOpenQuestionsSeries.displayName = "PlusArchiveQOpenQuestionsSeries";
